'use client'
import { RedditWithOriginUrl, SocialsType } from '@/services/coin/social'

import BaseCard from '../BaseCard'
import { parseReddit } from './parser'

export type Props = {
  data: RedditWithOriginUrl
}

export default function RedditCard({ data }: Props) {
  if (!data) return null
  const { username, title, text, originUrl } = data

  const media = parseReddit(data)

  return (
    <BaseCard
      title={title}
      description={text}
      thumbnail={media?.href}
      source={username}
      pubDate={String(data.create_time)}
      type={SocialsType.Reddit}
      link={originUrl}
    />
  )
}
